import type { AddToCartPayload } from '@/domains/shoppingCart/AddToCart/AddToCart.actions';

export const ADD_TO_CART_WATCH_REQUEST =
  'watchAddToCart/ADD_TO_CART_WATCH_REQUEST';

export type AddToCartWatchPayload = AddToCartPayload;

export interface AddToCartWatchAction {
  type: typeof ADD_TO_CART_WATCH_REQUEST;
  payload: AddToCartWatchPayload;
}

export const addToCartWatch = (payload: AddToCartWatchPayload) => ({
  type: ADD_TO_CART_WATCH_REQUEST,
  payload,
});
